<template>
  <div v-if="loaded">
    <sc-panel-navigator
        @update="updateFile"
        @delete="removeFile"
        :drawerWidth="500">
      <q-card class=" bg-teal-10 q-pa-xs text-white shadow">
        <q-card-section class=" q-pa-xs "
        >
          <el-row>
            <el-col :span="21">
              <ctk-dater
                  range
                  default="thisyear"
                  v-model="bookingRange"
                  display-format="dd/MM/yyyy"
                  export-format="DD/MM/YYYY"></ctk-dater>
            </el-col>
            <el-col :span="3">
              <sf-button
                  plain
                  type="primary"
                  style="float:right"
                  @click="++clock">
                <fa
                    icon="retweet"
                    fixed-width
                    size="lg"></fa>
              </sf-button>
            </el-col>
            <el-col :span="24" style="padding: 5px">
              <TripTypeSelector v-model="workingTripTypes"/>
            </el-col>
          </el-row>
          <el-row
              class="clearfix">
            <el-col :span="21">
              <s-remote-select
                  style="width:100%"
                  :dark="true"
                  v-model="coid"
                  class-model="tourcompany"
                  query-prop="q"
                  label-prop="coname"
                  placeholder="Search by company"></s-remote-select>
            </el-col>
            <el-col :span="3">
              <sf-button
                  plain
                  type="success"
                  style="float:right"
                  @click="importDialog=!importDialog">
                <fa
                    icon="file-upload"
                    fixed-width
                    size="lg"></fa>
              </sf-button>
            </el-col>
          </el-row>
          <el-row>
            <q-input dense dark
                     v-model="bookingsearch"
                     placeholder="Search bookings"
                     clearable></q-input>
          </el-row>
          <el-row>
            <q-input dense dark
                     v-model="filesearch"
                     placeholder="Search filename"
                     clearable></q-input>
          </el-row>
          <el-row>

            <s-remote-select
                placeholder="Search Hotels and places"
                :safeMode="false"
                v-model="ppid"
                :dark="true"
                class-model="pup"
                query-prop="q"
                label-prop="name"
                captionField="loc_name"
                prefixField="typename"
            ></s-remote-select>
          </el-row>
        </q-card-section>
        <q-separator/>
        <q-card-section class=" q-pa-xs ">
          <s-table
              :key="clock"
              :noWrap="false"
              ref="filesList"
              :colDefinitions="colFileDefinitions"
              route-query-prefix="files"
              xmodx-processor="reservations/files/getlist"
              lara-processor="files"
              :r-query="qFiles"
              @cell-clicked="goToFile"></s-table>
        </q-card-section>
      </q-card>
    </sc-panel-navigator>
    <s-modal
        sizeH="80%"
        title="Import data tool"
        v-model="importDialog"
        cvisible.sync="importDialog">
      <q-list bordered class="rounded-borders">
        <q-expansion-item
            expand-separator
            v-model="panel.loader"
            icon="file_upload"
            label="File Uploader"
            caption="Import excel,csv,pdf files"
        >
          <el-card
              ref="form"
              label-width="150px"
              v-if="importDialog">
            <el-row :gutter="20">
              <el-col :md="10">
                <h4>Associate bookings to related service</h4>
                <p>
                  <s-remote-select
                      style="width:100%"
                      v-model="working_co_id"
                      class-model="tourcompany"
                      query-prop="q"
                      label-prop="coname"
                      placeholder="Search by company"></s-remote-select>
                </p>
              </el-col>
              <el-col :md="10">
                <h4>Associate bookings to related service</h4>
                <p>
                  <s-remote-select
                      style="width:100%"
                      v-model="working_strip_id"
                      class-model="tripservice"
                      query-prop="search"
                      label-prop="title"
                      placeholder="Service title"></s-remote-select>
                </p>

              </el-col>
              <el-col :md="4"
                      label="Date Format">
                <h4>Date Format in file</h4>
                <el-select
                    v-model="dateformat"
                    placeholder="Select">
                  <el-option
                      label="Auto"
                      value="auto"></el-option>
                  <el-option
                      label="D/M/Y"
                      value="normal"></el-option>
                  <el-option
                      label="M/D/Y"
                      value="notnormal"></el-option>
                </el-select>
              </el-col>
            </el-row>
            <el-row
                :gutter="20"
                id="uploader">
              <div>
                <el-upload
                    v-if="working_co_id"
                    class="upload-demo"
                    drag

                    :data="uploadParams"
                    action="/assets/components/travel/connector.php"
                    xfile-list="files"
                    :multiple="true"
                    :before-upload="reset"
                    :on-success="goProcessFile">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">
                    drop file here <em>or click to select</em>
                  </div>
                  <!-- <div class="el-upload__tip" slot="tip">jpg/png files with a size less than 500kb</div> -->
                </el-upload>
                <q-card v-else>
                  <q-card-section>Please select a company before uploading a file</q-card-section>
                </q-card>
                <!--            <div>-->
                <!--            <el-button @click="goProcessFile(true)" v-if="$route.params.fileid&&$route.params.fileid!='all'">Scan-->
                <!--              again the-->
                <!--              selected file-->
                <!--            </el-button>-->
                <!--            </div>-->

              </div>
            </el-row>
            <el-row>
              <el-alert
                  v-if="progressMsg"
                  :title="progressMsg"
                  type="success"
                  :closable="false"></el-alert>
            </el-row>
          </el-card>
        </q-expansion-item>
        <q-expansion-item expand-separator
                          v-model="panel.errors"
                          icon="warning"
                          label="Problems"
                          v-if="!processing&&proccessErrors?.length">
          <div
              v-if="proccessErrors?.length"
          >
            <h4>Probably there are routes that have been removed. I suggest you rebuild the routes again</h4>
            <div

                v-for="(err,idx) in proccessErrors"
                :key="idx"
                v-html="err"
                style="background: red;color: white;margin: 3px;font-weight: bold"></div>

          </div>


        </q-expansion-item>
        <q-expansion-item
            v-model="panel.sum"
            v-if="lastUploadedFileId"
            expand-separator
            icon="summarize"
            label="Summary Info"
            caption="by date / trip / location"
        >
          <tree-reporter :r-query="{fileid:lastUploadedFileId}" lara-processor="bookings"
                         :col-definitions="bookingCols"
                         :pivot-cols="['tripDateTime','tripTitle','loc_code','pp_name']"
                         :aggr-cols="['pax','adults','children']" :expand-all="true"></tree-reporter>
        </q-expansion-item>
      </q-list>
      <span v-if="!processing"
            slot="header"
            class="dialog-footer">
          <span style="float:left;">File has been processed</span>
        <sf-button @click="closeAndGo" style="float: right">Done</sf-button>
        <!-- <el-button type="primary" @click="importDialog = false">Confirm</el-button> -->
      </span>
    </s-modal>
  </div>
</template>


<script>
import {mapActions, mapGetters} from "vuex";
import _ from "lodash";
import * as dateHelper from "date-fns";
import * as api from "~/api/resource";

import printHtml from "~/mixins/printHtml";
import {fetchProcessor} from "../../../api/resource";
import TripTypeSelector from "../TRIPS/TripTypeSelector.vue";

let processingTimer = {}
export default {
  components: {TripTypeSelector},
  mixins: [printHtml],
  data() {
    return {
      processing: true,
      bookingCols: [
        {
          prop: "tripDateTime",
          label: "Date",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            return vm.formatUnxTime(val);
          }
        },
        {
          prop: "tripTitle",
          label: 'Trip'
        },
        {
          prop: "loc_code",
          label: 'Resort'
        },
        {
          prop: "pp_name",
          label: 'Accommodation'
        },
        {
          prop: "adults",
          label: 'Adults'
        },
        {
          prop: "children",
          label: 'Children'
        },
        {
          prop: "pax",
          label: 'Pax'
        },
        {
          prop: "customer",
          label: 'Customer'
        },
        {
          prop: "reference",
          label: 'Reference'
        }

      ],
      lastUploadedFileId: null,
      proccessErrors: [],
      clock: 0,
      uploadParams: {//
        HTTP_MODAUTH: window.Travel.auth,
        ctx: "web",
        action: "reservations/files/import",
      },
      filesearch: null,
      // ppid: null,
      dateformat: "auto",
      importDialog: false,
      panel: {loader: true, errors: false, sum: false},
      printData: null,
      printReady: false,
      working_co_id: null,
      working_strip_id: null,
      loaded: false,
      timelineView: false,
      page: 1,
      progressMsg: null,
      // bookingsearch:null,
      // coid: null,
      // bookingRange: [],
      bookingRangeA: "",
      bookingRangeZ: "",
      cols: {},
      // dateFormat: "DD/MM/YY",
    };
  },
  methods: {
    reset() {
      this.progressMsg = null
      this.proccessErrors = []
      this.processing = true
      this.panel = {loader: true, errors: false, sum: false}
      this.lastUploadedFileId = null;
    },
    closeAndGo() {

      this.importDialog = false;
      // _log_("SUCCESS ", data);
      ++this.clock;
      this.goToFile(this.lastUploadedFileId, true);
      this.reset()
    },
    async goProcessFile(response) {
      this.processing = true
      // _log_("SUCCESS goProcessFile ", response.object.file_id, response);
      if (response && response.object && response.object.file_id) {
        this.$message({
          message:
              "Upload was a huge sucess :), now I am going to process the file...",
          type: "success",
        });
      }
      if (response === true && this.$route.params.fileid && this.$route.params.fileid != 'all')
        this.lastUploadedFileId = this.$route.params.fileid
      else
        this.lastUploadedFileId = response.object.file_id
      this.followProcessProgress(this.lastUploadedFileId)
      try {
        const {data} = await api.fetchProcessor("reservations/files/import", {
          limit: 0,
          sort: "ppid",
          info: 1,
          file: response?.object?.file_id || this.lastUploadedFileId,
          // objectId: response.object.file_id,
          file_type: this.userDomain,
          companyid: this.working_co_id,
          sTripId: this.working_strip_id,
          dateformat: this.dateformat,
        });

        clearInterval(processingTimer[response.object.file_id]);
        delete processingTimer[response.object.file_id]

        if (data.object && data.object.length) this.proccessErrors = [...this.proccessErrors, ...data.object.filter(m => m != 'done')]
        else {
          if (Object.values(processingTimer)?.length) return
          // this.importDialog = false;
          // _log_("SUCCESS ", data);
          ++this.clock;
          if (response?.object?.file_id)
            this.goToFile(response.object.file_id, true);
        }
        _log_("processingTimer ", this.proccessErrors);
        this.panel.errors = this.proccessErrors?.length
        this.panel.loader = false
        this.processing = false
        this.panel.sum = !this.panel.errors
      } catch (e) {
        clearInterval(processingTimer[response?.object?.file_id || this.lastUploadedFileId]);
        this.processing = false
        return
      }
      //selected_file=$event.object.file_id;progressMsg='Upload was a huge sucess :), now I am going to process the file...';pipeActions(['=>reservations/files/import','->checkUnRoutes','=>reservations/files/get>=fileInfo','=>reservations/getlist>=processLog','->reloadFileList','->swichModals'],{limit:0,sort:'ppid',info:1,objectId:$event.object.file_id,file:$event.object.file_id,file_type:'[[!+domain]]',companyid:working_co_id,deteformat:dateformat}); followProcessProgress($event.object.file_id)
    },
    updateFile(e) {
      // _log_("update...", e);
      this.$refs.filesList.updateOrAppendRow(e);
    },
    removeFile(payload) {
      // _log_("dleting...", payload);
      // this.routeGo({ name: "customers" });
      this.$refs.filesList.reload();
      // this.$refs.filesList.removeRow(payload);
    },
    async goPrintThis() {
      var {data} = await api.fetchProcessor("bookings/vuebookings", {
        daterange: this.bookingRange[0] + "-" + this.bookingRange[1],

        coid: this.coid,
        limit: 0,
      });
      this.printData = data.results;
      this.printReady = true;
    },
    changeCompany(coid) {
      var vm = this;
      this.$confirm(
          "This will change the Tour company releated to these bookings. Continue?",
          "Warning",
          {
            confirmButtonText: "OK",
            cancelButtonText: "Cancel",
            type: "warning",
          }
      )
          .then(() => {
            chainedAjax(
                "reservations/files/updateall",
                {file_id: this.selected_file, companyid: coid},
                function (res) {
                  if (res)
                    vm.$message({
                      type: "success",
                      message: "Ok Done",
                    });
                }
            );
          });
    },
    goAutoRoute() {
      const vm = this;
      //  @click="pipeActions(['=>route/autocomposer','->goToRutes'],{file_id:selected_file,file_ids:selected_files});"
      chainedAjax(
          "route/autocomposer",
          {
            file_id: this.selected_file,
            file_ids: this.selected_files,
            checkRutes: true,
          },
          function (res) {
            if (res.results && res.results.length)
              $.confirm({
                title: "You should know!",
                content:
                    "A lot of these bookings jhave already been routed. If you proceed you may loose any changes you have made!",
                buttons: {
                  viewRoutes: {
                    text: "Let me see the routes",
                    btnClass: "btn-blue",
                    keys: ["enter",
                      "shift"],
                    action: function () {
                      goToRutes(res);
                    },
                  },
                  buildRoutes: {
                    text: "I want to rebuild the routes",
                    btnClass: "btn-red",
                    keys: ["enter",
                      "shift"],
                    action: function () {
                      chainedAjax(
                          "route/autocomposer",
                          {
                            file_id: vm.selected_file,
                            file_ids: vm.selected_files,
                          },
                          function (res) {
                            goToRutes(res);
                          }
                      );
                    },
                  },
                  cancel: function () {
                  },
                },
              });
            else
              chainedAjax(
                  "route/autocomposer",
                  {file_id: vm.selected_file, file_ids: vm.selected_files},
                  function (res) {
                    goToRutes(res);
                  }
              );
          }
      );
    },

    followProcessProgress(file) {
      const vm = this;
      _log_("go...", file);
      // return
      processingTimer[file] = setInterval(function () {
        // _log_('try');
        let t = new Date().getTime();
        // <span id="#checkprogress" controller objectid
        // action="reservations/files/progress" target=""></span>
        api.fetchProcessor("reservations/files/progress")
            .then(res => {
              _log_('progress', res)
              vm.progressMsg = file + ' > ' + res?.data?.message
              if (vm.progressMsg == "finished")
                clearInterval(processingTimer[file]);
            })
            .catch(res => {
              clearInterval(processingTimer[file]);
            })

        // $.ajax({
        //   url: connector + "?time=" + t,
        //   type: "POST",
        //   dataType: "json",
        //   data: {
        //     action: "reservations/files/progress",
        //     HTTP_MODAUTH: Travel.auth,
        //     ctx: "web",
        //   },
        //   error: function () {
        //     clearInterval(processingTimer);
        //     //console.error("something went wrong");
        //   },
        //   success: function (res) {
        //     vm.progressMsg = res.message;
        //     if (res.message == "finished") clearInterval(processingTimer);
        //   },
        // });
      }, 3000);
    },

    goToFile(data, display_info) {
      // if (data.row?.log?.type == 'control-file') {
      //   this.$message('please wait file is downloading')
      //   api.ajax_download("vue_booking/getlist", {
      //     file_id: data.row.id,
      //     download: 'sunweb-fidelity'
      //   });
      // } else
      this.routeGo({
        name: "fileBookings",
        params: {fileid: data.row ? data.row.id : data},
        query: {display_file_info: display_info ? display_info : null}
      });
    },
  },
  async mounted() {
    const date = new Date();
    // this.bookingRange = [
    //   dateHelper.format(dateHelper.startOfToday(), "DD/MM/YYYY"),
    //   dateHelper.format(dateHelper.endOfTomorrow(), "DD/MM/YYYY")
    // ];
    //  [
    //   date.getTime(),
    //   date.getTime() + 3600 * 1000 * 24 * 91
    // ];
    _log_("FILES..", this.$route);

    this.loaded = true;
    // _log_("the rs///", this.rooms);
  },
  watch: {
    importDialog(v, vo) {
      if (v !== vo) {
        this.proccessErrors = []
        this.processing = true
      }
    }
  },
  computed: {
    workingTripTypes: {
      get() {

        if (!this.$route.query.tripType) {
          console.error("Route corrupted, no trip kind specified");
          return;
        }
        return this.$route.query.tripType.toUpperCase()
        // .split(',');
      },
      set(v) {
        if (!v) return
        if (!v.length) return
        this.routeGo({query: {tripType: v && _.isArray(v) ? v.join(',') : v}})
      }
    },
    ppid: {
      set(v) {

        this.routeGo(
            {
              params: {fileid: 'all'},
              query: {ppid: v},
            }
        );

        return;
      },
      get() {
        return this.$route.query.ppid ? this.$route.query.ppid : null
      },
    },
    coid: {
      set(v) {

        this.routeGo(
            {

              query: {coid: v},
            }
        );

        return;
      },
      get() {
        return this.$route.query.coid ? this.$route.query.coid : null
      },
    },
    bookingsearch: {
      set(v) {

        this.routeGo(
            {
              params: {fileid: 'all'},
              query: {query: v},
            }
        );

        return;
      },
      get() {
        return this.$route.query.query ? this.$route.query.query : null
      },

    },
    workingKind() {
      _log_("the main params...", this.$route.params);

      if (!this.$route.params.kind) {
        console.error("Route corrupted, no file kind specified");
        return;
      }
      return this.$route.params.kind.toUpperCase();
    },
    ...mapGetters({
      rooms: "hotelinfo/rooms",
    }),
    // qBookings() {
    //   return { "bookingRange[]": bookingRange, coid: coid };
    // },
    qFiles() {

      let q = {
        range: this.bookingRange,
        indexFiles: true
      };
      if (this.coid) q["coid"] = this.coid;
      if (this.bookingsearch) q.customerSearch = this.bookingsearch
      if (this.workingTripTypes) q.workingTripTypes = this.workingTripTypes
      if (this.filesearch) q.filesearch = this.filesearch
      if (this.ppid) q.ppid = this.ppid
      // _log_(">>QP>>", q);
      return q;
    },
    colFileDefinitions() {
      var rw = "580px";
      if (window.innerWidth < 500) rw = "180px";
      if (window.innerWidth < 700) rw = "280px";
      if (window.innerWidth < 1000) rw = "380px";
      return [
        // {
        //   prop: "paymentStatus",
        //   width: "120px",
        //   label: "Πληρωμή",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-payment"
        //   }
        // },

        {
          prop: "uploaded_on",
          width: "130px",
          label: "Date",
          formatter: function (val, colDefs, row, vm) {

            return (
                '<span class="el-tag el-tag--small el-tag--light" style="float: left"> ' +
                row.id +
                "</span><span style='padding-left:4px;float: right' >" +
                vm.formatDate(val) + "</span>"
            );
          },
        },

        {
          prop: "name",
          minWidth: "150px",
          label: "File",
          formatter: function (val, colDefs, row, vm) {
            // _log_(">>>>" + val, row);
            let caption = row.subject || (val.replace(".html", "")
                .replace(".htm", ""));
            const prefix = row.log?.type == 'flights' ? '<i class="label label-success smicon material-icons">flight_land</i>' : '<i class="material-icons">location_city</i>'
            return prefix + (
                '<a href="/assets/components/travel/imports/' +
                val +
                '" target="blank">' +
                caption +
                "</a>"
            );
          },
        },
        {
          prop: "company", width: "100px", label: "Source",
          formatter: function (val, colDefs, row, vm) {
            return val?.coname
          }
          // formatter(val, col, row) {
          //
          //   if (row?.log?.type == 'control-file')
          //     return (val || '') + '<span class="material-icons">\n' +
          //         'cloud_download\n' +
          //         '</span>'
          //   return val
          // }
        },
        // {
        //   prop: "timetime",
        //   width: "",
        //   label: "Time",
        //   formatter: function(val, colDefs, row, vm) {
        //     return vm.formatUnxTime(row.time, true);
        //   }
        // },
        // {
        //   prop: "pax",
        //   width: "80px",
        //   label: "PAX",
        //   formatter: function(val, cols, row) {
        //     var pax = val ? val : 0,
        //       cpax = row.canceled
        //         ? '<span style="font-size:10px;color:red">' +
        //           row.canceled +
        //           "</span>/"
        //         : "";

        //     // _log_(">>>>" + val, row);
        //     return cpax + '<span style="font-weight:bold">' + pax + "</span>";
        //   }
        // }
        // {
        //   prop: "roomsF",
        //   width: rw,
        //   label: "Κράτηση",
        //   displayClass: "el-tag el-tag--info",
        //   component: {
        //     is: "v-rooms"
        //   }
        // }
      ];
    },
  },
};
</script>

<style>
.search.x-row {
  align-items: flex-start;
}

.has-more {
  color: red;
  font-weight: 700;
}
</style>
